import { ClassicFlow } from '../flow'

export function setup() {
  return () => new ClassicFlow()
}
